import React from 'react'
import Button from '../../../../atoms/Button/Button'
import FormField from '../../../../atoms/FormField/FormField'
import FormInput from '../../../../atoms/FormInput/FormInput'
import { trackingCheckout } from '../../../../../utils/gtm'
import useTrans from '../../../../../hooks/useTrans'
import { useSelector } from 'react-redux'
import FormCheckbox from '../../../../atoms/FormCheckbox/FormCheckbox'

const BozzaDigitale = ({ step, setStep, props, carrello_main }) => {
  const t = useTrans()
  const { utente } = useSelector((state) => state.utente)

  return (
    <div className="step-registrazione">
      <div className="step-registrazione__fieldsets">
        <FormField
          label={t('E-MAIL Per ricevere la bozza digitale')}
          infoMessage={t('Riceverai la bozza digitale da approvare al seguente indirizzo')}
        >
          <FormInput
            value={utente?.email || props.values.utente?.username}
            placeholder={t('Inserisci la mail')}
            disabled
          />
        </FormField>

        <FormField className="step-registrazione__fieldset--full-row">
          <FormCheckbox
            label={t("Ricevi la bozza dell'ordine anche su un altro indirizzo")}
            onChange={() => {
              props.setFieldValue(
                'email_bozza_digitale_diversa',
                !props.values.email_bozza_digitale_diversa
              )
              if (!props.values.email_bozza_digitale_diversa) {
                props.setFieldValue('email_bozza_digitale', null)
              }
            }}
            checked={props.values.email_bozza_digitale_diversa}
            onBlur={props.handleBlur('email_bozza_digitale_diversa')}
          />
        </FormField>

        {props.values?.email_bozza_digitale_diversa && (
          <FormField
            status={
              props.touched.email_bozza_digitale && props.errors.email_bozza_digitale
                ? 'error'
                : props.touched.email_bozza_digitale && 'success'
            }
            errorMessage={props.errors?.email_bozza_digitale}
            label={t('E-mail')}
          >
            <FormInput
              value={props.values.email_bozza_digitale}
              placeholder={t('Inserisci la mail')}
              onBlur={props.handleBlur('email_bozza_digitale')}
              onChange={props.handleChange('email_bozza_digitale')}
            />
          </FormField>
        )}
      </div>

      <Button
        label="Conferma dati"
        size="medium"
        variant="primary"
        disabled={props.errors.email_bozza_digitale}
        onClick={() => {
          setStep(step + 1)
          trackingCheckout(carrello_main, 4, props.values?.documento)
        }}
        className="checkout__conferma-button"
      />
    </div>
  )
}

export default BozzaDigitale
